<div *ngIf="ctx" class="row align-items-center justify-content-end g-0 mt-0" [ngClass]="'vpdo-row-' + activeViewKindCount()">
  <div class="col">
    <app-voorraad-prijs-opties [ctx]="ctx" (stockOptionChanged)="onStockOptionChanged($event)" (netPriceOptionChanged)="onNetPriceOptionChanged($event)"></app-voorraad-prijs-opties>
  </div>
  <div *ngIf="!disableDisplayOptions" class="col ps-2">
    <app-display-opties [ctx]="ctx" [viewKinds]="viewKinds" (viewKindChanged)="onViewKindChanged($event)"></app-display-opties>
  </div>
</div>
